// Theater009.js
import React from 'react';
import './Alt.css'; // Import your additional CSS

const Theater009 = () => {

  const imageUrl ='https://lh5.googleusercontent.com/p/AF1QipMa6H7fKHJQ3SpeN48lbfcU4P32v3xo13n71jYw=w408-h272-k-no';

  return (
    <div className="container">
      <div className="post">
        <div className="title-overlay">Mark Taper Forum</div> {/* Explicitly specify the title here */}
        <img src={imageUrl} alt="Mark Taper Forum"/>
      </div>
    </div>
  );
};

export default Theater009;
